import React, { useState, useEffect } from "react";
import {
  FaBoxOpen, FaMoneyBillWave, FaTags, FaFileAlt, FaListUl, FaUser, FaPhone, FaEnvelope, FaBuilding, FaMapMarkerAlt, FaFileInvoice, FaImage, FaIdCard, FaFilePdf, FaSearch, FaPlus, FaTimes
} from "react-icons/fa";

import axios from 'axios'
import toast from "react-hot-toast";
import Select from 'react-select';
import { Button, Card } from "react-bootstrap";
import { MdDeleteForever } from "react-icons/md";
import { useRef } from "react";


function CategoryMaster({token}) {

     const [showForm, setShowForm] = useState(false);
      const [editingCompanyId, setEditingCompanyId] = useState(null);
      const [isEditMode, setIsEditMode] = useState(false);
      const [searchTerm, setSearchTerm] = useState('');
      const [category, setCategory] = useState([]);
      const [showDeleteModal, setShowDeleteModal] = useState(false);
      const [selectedDelete, setSelectedDelete] = useState(null);
      const [file, setFile] = useState(null);
      const [excelData, setExcelData] = useState([]);
      const fileInputRef = useRef(null);
      const[bussCat,setBussCat] = useState([]);


       const [formData, setFormData] = useState({
        category:'',
       img:null,
       buss_name:'',
       sr_no:'',
        });
      
      
        const handleInputChange = (e) => {
          const { name, value, files } = e.target;
          if (name === "profile") {
            setFormData({ ...formData, [name]: files[0] });
          } else {
            setFormData({ ...formData, [name]: value });
          }
        };
      


const handleSubmit = async (e) => {
  e.preventDefault();

  try {
    const data = new FormData();

    data.append("category", formData.category);
     data.append("buss_name", formData.buss_name);
     data.append("sr_no", formData.sr_no);

    if (formData.img) {
      data.append("img", formData.img);
    }

    if (isEditMode) {
      let oldImgeName = "";

      if (formData.imgPreview) {
        const parts = formData.imgPreview.split("/");
        oldImgeName = parts[parts.length - 1];
      }

      data.append("oldImgeName", oldImgeName);

      await axios.put(
        `https://api.krimotion.in/update-master-category/${formData.id}`,
        data,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      toast.success("Category updated successfully!");
    } else {
      await axios.post(
        "https://api.krimotion.in/add-master-category",
        data,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      toast.success("Category Added Successfully!");
    }

    resetForm();
    setShowForm(false);
    setIsEditMode(false);
    fetchMasterCategory();

  } catch (error) {
    toast.error( error.response?.data?.message ||
      "Something went wrong");
    console.error(error);
  }
};


    const fetchMasterCategory = async () => {
    try {
      const res = await axios.get("https://api.krimotion.in/fetch-master-category",
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      const result = res.data;

      setCategory(result);
    } catch (error) {
      console.log(error);
    }
  };

     const fecthBusinesCat = async () => {
    try {
      const res = await axios.get("https://api.krimotion.in/fetch-business-category",
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      const result = res.data;

      setBussCat(result);
    } catch (error) {
      console.log(error);
    }
  };

  const businessOptions = bussCat.map((item) => ({
  value: item.id,
  label: item.buss_name,
}));

  useEffect(() => {
    fetchMasterCategory();
   fecthBusinesCat();
  }, []);


  const handleDeleteCategory = async () => {
    try {
      const res = await axios.delete(
        `https://api.krimotion.in/delete-master-category/${selectedDelete.id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      toast.success("Deleted Successfuly!");

      setShowDeleteModal(false);
      setSelectedDelete(null);

      fetchMasterCategory();
    } catch (error) {
      toast.error(error.response?.data?.message || "Something went wrong");
    }
  };

  const handleEdit = (form) => {

  setIsEditMode(true);
 
  setFormData({
    id: form.id || "",
    category: form.category || "",
      buss_name: form.buss_name || "",
      sr_no:form.sr_no || "",

   imgPreview: form.img
      ? `https://api.krimotion.in/uploads/${form.img}`
      : null,

  });

  setEditingCompanyId(form.id);
  setShowForm(true);
};


    const resetForm = () => {
    setFormData({
    category:'',
   img: null,
   imgPreview:null
    });

    setIsEditMode(false);
    setEditingCompanyId(null);


  };


   const handlePreviewImage = (url, file) => {
  if (file) {
    // preview newly selected file
    const previewUrl = URL.createObjectURL(file);
    window.open(previewUrl, "_blank");
  } else if (url) {
    // preview existing image
    window.open(url, "_blank");
  }
};


  
  const filteredData = Array.isArray(category)
    ? category.filter(itm =>
      Object.values(itm).some(val =>
        String(val).toLowerCase().includes(searchTerm.toLowerCase())
      )
    )
    : [];


const getBusinessName = (id) => {
  const business = bussCat.find((item) => item.id === id);
  return business ? business.buss_name : "";
};
  return (
   <div className="container py-4">
        <div className="border-0  mb-3 px-2 py-2  ">
  
          <div className="d-flex align-items-center justify-content-between flex-wrap gap-2">
  
            {/* LEFT TITLE */}
            <div className="d-flex align-items-center">
              <h4 className="fw-bold mb-0" style={{ fontSize: "20px" }}>
                Manage Master Category
              </h4>
            </div>
  
            {/* CENTER SEARCH */}
            <div style={{ flex: 1, maxWidth: "250px" }}>
              <div
                className="d-flex align-items-center rounded-pill overflow-hidden"
                style={{
                  border: "1px solid var(--green)",
                  height: "34px",
                  paddingLeft: "8px",
                  paddingRight: "8px",
                  backgroundColor: 'white'
                }}
              >
                {/* ICON */}
                <FaSearch
                  style={{
                    color: "var(--green)",
                    fontSize: "14px",
                    display: "flex",
                    alignItems: "center"
                  }}
                />
  
                {/* INPUT */}
                <input
                  type="text"
                  className="form-control border-0 shadow-none"
                  placeholder="Search..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  style={{
                    fontSize: "14px",
                    height: "32px",
                    marginLeft: "6px",
                    lineHeight: "32px"
                  }}
                />
              </div>
            </div>
  
            {/* RIGHT BUTTON */}
            <div className="d-flex align-items-center gap-2">
              {!showForm ? (
                <>
                  <button
                    className="btn btn-sm px-3 "
                    onClick={() => setShowForm(true)}
                    style={{
                      backgroundColor: "var(--green)",
                      color: "white",
                      fontSize: "13px",
                      height: "34px"
                    }}
                  >
                    <FaPlus className="me-1" />
                    Add
                  </button>
  
                </>
              ) : (
                <button
                  className="btn btn-danger btn-sm px-3"
                  onClick={() => {
                    resetForm();
                    setShowForm(false);
                  }}
                  style={{ height: "34px", fontSize: "13px" }}
                >
                  <FaTimes className="me-1" />
                  Close
                </button>
              )}
            </div>
  
          </div>
        </div>
  

  
  
        {showForm && (
          <div className="card shadow-sm border-0 rounded-4 p-3">
  
            <form onSubmit={handleSubmit}>
              <div className="row g-3">
  

    <div className="col-md-4">
  <label className="form-label fw-semibold">
    Select Business Category
  </label>

  <div className="input-group">
  
    <Select
  options={businessOptions}
  placeholder="Select Business Category"
  value={
    businessOptions.find(
      (option) => option.value === formData.buss_name
    ) || null
  }
  onChange={(selectedOption) =>
    setFormData({
      ...formData,
      buss_name: selectedOption?.value || "",
    })
  }
  className="w-100"
/>
  </div>
</div>
  
                <div className="col-md-4">
                  <label className="form-label fw-semibold">Category Name</label>
                  <div className="input-group">
                    <span className="input-group-text">
                      <FaBoxOpen />
                    </span>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter name"
                      name="category"
                      value={formData.category}
                      onChange={handleInputChange}
                      required
                    />
                  </div>
                </div>
  
  
  <div className="col-md-4">
  <label className="form-label fw-semibold">Select Image</label>

  <div className="input-group">
    <input
      type="file"
      className="form-control"
      accept="image/*"
      onChange={(e) =>
        setFormData({
          ...formData,
          img: e.target.files[0],
        })
      }
    />

    
  </div>

 {isEditMode && formData.imgPreview && (
    <div className="ms-2 align-content-center mt-1">
      <button
        type="button"
        className="btn-action btn-primary-custom"
        onClick={() =>
          handlePreviewImage(formData.imgPreview, formData.img)
        }
      >
        Preview
      </button>
    </div>
  )}
</div>


 <div className="col-md-4">
  <label className="form-label fw-semibold">Sr No.</label>
    <div className="input-group">
                    <span className="input-group-text">
                      <FaBoxOpen />
                    </span>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter name"
                      name="sr_no"
                      value={formData.sr_no}
                      onChange={handleInputChange}
                    
                    />
                  </div>
  </div> 
  
  
                {/* Save Button */}
                <div className="col-12 text-end">
                  <button type="submit" className="btn-action btn-success-custom" style={{ backgroundColor: "var(--green)", color: 'white' }}>
                    {isEditMode ? "Update  " : " Save "}
                  </button>
                </div>
  
              </div>
            </form>
          </div>
        )}
  
      
{!showForm && (
  <div className="container-fluid mt-4">
    <div className="row g-4">

      {filteredData.length > 0 ? (
        filteredData.map((dealer, index) => (

//           <div className="col-xl-4 col-lg-6 col-md-6" key={index}>

//             <div className="inventory-card d-flex flex-column h-100">

//               {/* Header */}
//               <div className="d-flex justify-content-between align-items-center mb-3">

//                 <h5 className="fw-bold mb-0">
//                   {dealer.category}
//                 </h5>
//               </div>
//               <div className="inventory-row">
//                 <span className="inventory-label">
//                  Category Name
//                 </span>

//                 <span>{dealer.category}</span>
//               </div>


              
//               <div className="inventory-row">
//                 <span className="inventory-label">
//                  Business Name
//                 </span>

//                 <span>{dealer.buss_name}</span>
//               </div>

//           <div className="mt-auto pt-3 d-flex justify-content-end gap-2">

//   <button
//     className="btn-action btn-primary-custom"
//     onClick={() => handleEdit(dealer)}
//   >
//     <i className="bi bi-pencil me-1"></i>
//     Edit
//   </button>

//   <button
//     className="btn-action btn-danger-custom"
//     onClick={() => {
//       setSelectedDelete(dealer);
//       setShowDeleteModal(true);
//     }}
//   >
//     <i className="bi bi-trash me-1"></i>
//     Delete
//   </button>

// </div>

//             </div>

//           </div>

<div className="col-md-6 col-lg-4 mb-4" key={dealer.id}>
  <div className="inventory-card h-100 p-3">

    <div className="d-flex align-items-center">

      {/* Left Side - Image */}
      <div className="me-3">
        <img
          src={
            dealer.img
              ? `https://api.krimotion.in/uploads/${dealer.img}`
              : ""
          }
          alt={dealer.category}
          style={{
            width: "90px",
            height: "130px",
            borderRadius: "12px",
            objectFit: "cover",
            border: "1px solid #ddd",
          }}
        />
      </div>

      {/* Right Side - Details */}
      <div className="flex-grow-1">

        <h5 className="fw-bold mb-3">
          {dealer.category}
        </h5>

        <div className="mb-2">
          <strong>Category Name:</strong>
          <br />
          {dealer.category}
        </div>

        <div>
          <strong>Business Name:</strong>
          <br />
       <span>{getBusinessName(dealer.buss_name)}</span>
        </div>

           <div>
          <strong>Sr No: </strong>
        
       <span>{dealer.sr_no || ""}</span>
        </div>

      </div>

    </div>

    {/* Buttons */}
    <div className="mt-4 d-flex justify-content-end gap-2">

      <button
        className="btn-action btn-primary-custom"
        onClick={() => handleEdit(dealer)}
      >
        <i className="bi bi-pencil me-1"></i>
        Edit
      </button>

      <button
        className="btn-action btn-danger-custom"
        onClick={() => {
          setSelectedDelete(dealer);
          setShowDeleteModal(true);
        }}
      >
        <i className="bi bi-trash me-1"></i>
        Delete
      </button>

    </div>

  </div>
</div>

        ))
      ) : (

        <div className="col-12">
          <div className="text-center py-5">
            No Data Found
          </div>
        </div>

      )}

    </div>
  </div>
)}
        
              {showDeleteModal && (
                <>
                  <div
                    className="modal-backdrop fade show"
                    onClick={() => {
                      setShowDeleteModal(false);
                      setSelectedDelete(null);
                    }}
                  ></div>
  
                  <div className="modal fade show d-block">
                    <div className="modal-dialog modal-dialog-centered">
                      <div
                        className="modal-content border-0 shadow-lg"
                        style={{ borderRadius: "16px" }}
                      >
  
                        <div className="modal-header bg-danger text-white">
                          <h5 className="modal-title fw-bold">
                            🗑 Delete Category
                          </h5>
  
                          <button
                            className="btn-close btn-close-white"
                            onClick={() => setShowDeleteModal(false)}
                          ></button>
                        </div>
  
  
                        <div className="modal-body text-center py-4">
  
                          <div style={{ fontSize: "60px" }}>⚠️</div>
  
                          <h5 className="mt-3 fw-bold">
                            Are you sure?
                          </h5>
  
                          <p className="text-muted mb-0">
                            You are about to permanently delete this category.
                          </p>
  
                          <h6 className="fw-bold text-dark mt-2">
                            {selectedDelete?.name}
                          </h6>
  
                          <p className="text-danger fw-semibold mt-2">
                            This action cannot be undone.
                          </p>
  
                        </div>
  
  
                        <div className="modal-footer border-0 justify-content-center">
  
                          <button
                            className="btn btn-outline-secondary px-4"
                            onClick={() => {
                              setShowDeleteModal(false);
                              setSelectedDelete(null);
                            }}
                          >
                            Cancel
                          </button>
  
                          <button
                            className="btn btn-danger px-4"
                            onClick={handleDeleteCategory}
                          >
                            🗑 Delete
                          </button>
  
                        </div>
  
                      </div>
                    </div>
                  </div>
                </>
              )}
      </div>
  )
}

export default CategoryMaster
